var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("span", { staticClass: "mr-2 font-weight-light" }, [
              _vm._v(_vm._s(_vm.$t("surveyResults")) + ":")
            ]),
            _vm._v(" "),
            _vm._l(_vm.visibleSurveys, function(survey) {
              return _c(
                "span",
                { key: survey.id, staticClass: "badge badge-info mr-1" },
                [
                  _vm._v(
                    " \t\n\t\t\t    " +
                      _vm._s(
                        _vm.getLocalizedSurveyNameFromSurvey(
                          survey,
                          "?",
                          _vm.$i18n.locale
                        )
                      ) +
                      "\n\t\t    "
                  )
                ]
              )
            }),
            _vm._v(" "),
            _vm.extraSurveysCount > 0
              ? _c("span", { staticClass: "badge badge-secondary" }, [
                  _vm._v(
                    "\n\t\t\t    +" +
                      _vm._s(_vm.extraSurveysCount) +
                      " " +
                      _vm._s(_vm.$t("more")) +
                      "\n\t\t    "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.surveys || _vm.surveys.length === 0
              ? _c("span", { staticClass: "text-muted small" }, [
                  _vm._v(
                    "\n\t\t\t    " +
                      _vm._s(_vm.$t("txtSearchNoRows")) +
                      "\n\t\t    "
                  )
                ])
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 mb-2 d-print-none" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-secondary float-right",
              attrs: { onclick: "window.print();return false;" }
            },
            [_vm._v(" " + _vm._s(_vm.$t("btnPrint")))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("VueGoodTable", {
        attrs: {
          columns: _vm.columnsConfig,
          "search-options": _vm.searchOptions,
          "pagination-options": _vm.paginationOptions,
          "sort-options": _vm.sortOptions,
          mode: "remote",
          rows: _vm.vgtManager.results.data,
          totalRows: _vm.vgtManager.results.totalRows,
          isLoading: _vm.vgtManager.isLoading
        },
        on: {
          "on-page-change": function($event) {
            _vm.vgtManager.pageEvent.bind(_vm.vgtManager)($event)
          },
          "on-sort-change": function($event) {
            _vm.vgtManager.sortEvent.bind(_vm.vgtManager)($event)
          },
          "on-column-filter": function($event) {
            _vm.vgtManager.filterEvent.bind(_vm.vgtManager)($event)
          },
          "on-per-page-change": function($event) {
            _vm.vgtManager.perPageEvent.bind(_vm.vgtManager)($event)
          },
          "on-search": function($event) {
            _vm.vgtManager.searchEvent.bind(_vm.vgtManager)($event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.passedColumn
                  ? _c("div", { staticClass: "d-flex flex-row" }, [
                      _c("div", { staticClass: "flex-grow-1" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(props.formattedRow[props.column.field]) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "btn-group ml-1" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-secondary",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.showAnswers(props.row)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-table" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "visible",
                                rawName: "v-visible",
                                value: _vm.hasSignature(props.row),
                                expression: "hasSignature(props.row)"
                              }
                            ],
                            staticClass: "btn btn-sm btn-secondary",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.showSignature(props.row)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-signature" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "visible",
                                rawName: "v-visible",
                                value: _vm.canSetEndDate,
                                expression: "canSetEndDate"
                              }
                            ],
                            staticClass: "btn btn-sm btn-danger",
                            attrs: {
                              disabled: _vm.settingEndDateIds.has(props.row.id)
                            },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.setEndDate(props.row)
                              }
                            }
                          },
                          [
                            _vm.settingEndDateIds.has(props.row.id)
                              ? _c("Spinner", { attrs: { small: true } })
                              : _c("i", { staticClass: "fa fa-stop" })
                          ],
                          1
                        )
                      ])
                    ])
                  : props.column.doneDateColumn
                  ? _c(
                      "div",
                      { staticClass: "d-flex flex-row" },
                      [
                        _c("div", { staticClass: "flex-grow-1" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.formattedRow[props.column.field]) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        props.row.doneDate.getTime() > Date.now()
                          ? [
                              _vm.hasAssemblyPoint(props.row)
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "ml-1",
                                      staticStyle: { color: "var(--orange)" }
                                    },
                                    [_c("i", { staticClass: "fa fa-circle" })]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "ml-1 text-danger" },
                                    [_c("i", { staticClass: "fa fa-circle" })]
                                  )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n        "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("AnswersModal", { ref: "answerModal" }),
      _vm._v(" "),
      _c("SignatureModal", { ref: "signatureModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }